import { apiFetch } from './client';

export function fetchMetaAccounts() {
  return apiFetch('/api/meta/accounts');
}

export function disconnectMeta() {
  return apiFetch('/api/meta/disconnect', { method: 'POST' });
}
